var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgApi = function SvgApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.828 9.405h3.577a.855.855 0 0 0 0-1.71H5.828a2.565 2.565 0 1 0 0 1.71zM3.42 9.8a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm15.994-1.854a.853.853 0 0 1 0 1.208l-2.565 2.565a.853.853 0 0 1-1.208-1.208l1.105-1.106h-3.11A8.56 8.56 0 0 1 5.13 17.1a.855.855 0 0 1 0-1.71c3.778 0 6.84-3.062 6.84-6.84S8.908 1.71 5.13 1.71a.855.855 0 0 1 0-1.71 8.561 8.561 0 0 1 8.506 7.695h3.11l-1.105-1.106a.853.853 0 0 1 1.208-1.208l2.565 2.565z",
    fill: "#87A0B2",
    fillRule: "nonzero"
  })));
};

export default SvgApi;